export const SELECTION_METHOD_BY_IDS = 'BY_IDS';
export const SELECTION_METHOD_BY_QUERY = 'BY_QUERY';
export const SELECTION_METHODS = {
  BY_IDS: SELECTION_METHOD_BY_IDS,
  BY_QUERY: SELECTION_METHOD_BY_QUERY
};